import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./InfoTip.scss";

// Small "i" icon that shows `text` on hover/focus. Rendered in a portal so it
// isn't clipped by scrolling tables or cards.
const InfoTip = ({ text, width = 260, style }) => {
  const iconRef = useRef(null);
  const [pos, setPos] = useState(null);

  const show = () => {
    const rect = iconRef.current?.getBoundingClientRect();
    if (!rect) return;
    const left = Math.max(8, Math.min(rect.left + rect.width / 2 - width / 2, window.innerWidth - width - 8));
    const openUp = window.innerHeight - rect.bottom < 140 && rect.top > 140;
    setPos(openUp ? { left, bottom: window.innerHeight - rect.top + 6 } : { left, top: rect.bottom + 6 });
  };
  const hide = () => setPos(null);

  return (
    <>
      <span
        ref={iconRef}
        className="info-tip-icon"
        style={style}
        tabIndex={0}
        role="img"
        aria-label={typeof text === "string" ? text : "More info"}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        onClick={(e) => e.stopPropagation()}
      >
        i
      </span>
      {pos && createPortal(
        <div className="info-tip-bubble" style={{ ...pos, width }}>{text}</div>,
        document.body
      )}
    </>
  );
};

export default InfoTip;
